// Úvod kolekce (sections/ai_collection-intro.liquid): text delší než zadaný počet řádků se zkrátí
// a tlačítko ho rozbalí. Ořez před doběhnutím skriptu dělá CSS (1lh); tady se změří skutečná výška
// a rozhodne, jestli tlačítko vůbec ukázat. Schová-li ořez nejvýš jeden řádek navíc, text zůstane
// celý – tlačítko, které odkryje jediný řádek, jen obtěžuje.
if (!customElements.get('kolekce-uvod')) {
  customElements.define(
    'kolekce-uvod',
    class KolekceUvod extends HTMLElement {
      connectedCallback() {
        this.text = this.querySelector('.kolekce-uvod__text');
        this.tlacitko = this.querySelector('.kolekce-uvod__vice');
        this.mobil = window.matchMedia('(max-width: 749px)');
        this.rozbaleno = false;
        if (!this.text || !this.tlacitko) return;
        this.tlacitko.addEventListener('click', () => this.prepni());
        this.sirka = 0;
        this.pozorovatel = new ResizeObserver(() => {
          // Jen změna šířky mění zalomení; změna výšky je náš vlastní max-height.
          if (this.offsetWidth === this.sirka) return;
          this.sirka = this.offsetWidth;
          this.zmer();
        });
        this.pozorovatel.observe(this);
      }

      disconnectedCallback() {
        if (this.pozorovatel) this.pozorovatel.disconnect();
      }

      radky() {
        return parseInt(this.mobil.matches ? this.dataset.radkyM : this.dataset.radkyD, 10) || 0;
      }

      vyskaRadku() {
        const styl = getComputedStyle(this.text);
        const lh = parseFloat(styl.lineHeight);
        return isNaN(lh) ? parseFloat(styl.fontSize) * 1.5 : lh;
      }

      zmer() {
        const radky = this.radky();
        const plna = this.text.scrollHeight;
        const orez = Math.round(radky * this.vyskaRadku());
        if (!radky || plna <= orez + this.vyskaRadku() * 1.5) {
          this.dataset.stav = 'cely';
          this.text.style.maxHeight = 'none';
          this.tlacitko.hidden = true;
          return;
        }
        this.orez = orez;
        this.tlacitko.hidden = false;
        this.nastav(this.rozbaleno);
      }

      nastav(rozbaleno) {
        this.rozbaleno = rozbaleno;
        this.dataset.stav = rozbaleno ? 'rozbaleno' : 'sbaleno';
        this.text.style.maxHeight = (rozbaleno ? this.text.scrollHeight : this.orez) + 'px';
        this.tlacitko.setAttribute('aria-expanded', rozbaleno ? 'true' : 'false');
        this.tlacitko.querySelector('span').textContent = rozbaleno
          ? this.tlacitko.dataset.mene
          : this.tlacitko.dataset.vice;
      }

      prepni() {
        const rozbalit = !this.rozbaleno;
        this.nastav(rozbalit);
        // Po sbalení dlouhého textu vrátit začátek úvodu do zorného pole.
        if (!rozbalit && this.getBoundingClientRect().top < 0) {
          this.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      }
    }
  );
}
